// extracted by mini-css-extract-plugin
module.exports = {"component":"ribbon_component__rdryI","ribbon":"ribbon_ribbon___ZLyq"};